/** Product code region abbreviation to region id number */
const abbrevToRegion = { AZ: 2, EU: 3 };

// eslint-disable-next-line import/prefer-default-export
export { abbrevToRegion };
